/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import {ListGroup} from 'external/react-bootstrap';

import { DateTimeDisplay } from 'plugin/base-portlet';
import { UserHistoryEntry } from 'plugin/user-state-history-portlet';
import StateValueLabel from '../components/StateValueLabel';

const StateValueListItem = ({item, children}) => {
    return (
        <ListGroup.Item>
            {children}
            <StateValueLabel item={item}/>{' '}
            {item.comment || ''}
            <br/>
            {item && item.userTimestamp && <span>Eingabezeitpunkt: <DateTimeDisplay timestamp={item.userTimestamp}/><br/></span>}
            <small className="text-muted"><UserHistoryEntry userMeta={item.userMeta}
                                                            timestamp={item.timestamp} /></small>
        </ListGroup.Item>
    );
};

StateValueListItem.propTypes = {
    item: PropTypes.object.isRequired,
    children: PropTypes.node
};


export default StateValueListItem;



// WEBPACK FOOTER //
// ./js/components/StateValueListItem.jsx